import React, { useState } from "react";
import EAModal from "../Modal/EAModal";
import { addYears } from "date-fns";
import EADayCalendar from "../EADayCalendar/EADayCalendar";

interface IProps {
  title?: string;
  onClose: () => void;
  date?: Date;
  onDatePick: (date: Date) => void;
  requireConfirmation?: boolean;
  unavailableDays?: Date[];
  fromDate?: Date;
  toDate?: Date;
}

const EACalendarModal: React.FC<IProps> = ({
  title = "Wybór dnia",
  onClose,
  date,
  onDatePick,
  requireConfirmation = false,
  unavailableDays,
  fromDate = new Date(),
  toDate = addYears(new Date(), 1),
}) => {
  const [tempSelectedDate, setTempSelectedDate] = useState<Date | undefined>(date);
  const selected = requireConfirmation ? tempSelectedDate : date;

  const handleSelect = (selectedDate: Date) => {
    if (requireConfirmation) {
      setTempSelectedDate(selectedDate);
      return;
    }
    onDatePick(selectedDate);
  };

  const handleConfirm = () => {
    if (tempSelectedDate) {
      onDatePick(tempSelectedDate);
    }
  };

  return (
    <EAModal
      isOpen
      onClose={onClose}
      title={title}
      hideAcceptButton={!requireConfirmation}
      acceptButtonLabel="Wybierz"
      onAccept={handleConfirm}
    >
      <div className="eamodal__calendar">
        <EADayCalendar
          selectedDate={selected}
          hasSelection={Boolean(selected)}
          onSelect={handleSelect}
          fromDate={fromDate}
          toDate={toDate}
          unavailableDates={unavailableDays}
        />
      </div>
    </EAModal>
  );
};

export default EACalendarModal;
